module.exports = __webpack_public_path__ + "img/online_bg_wap_2025_04_25.bf9d2b6c.png";